import './HowWork.css'
import React from "react";
import { useDarkMode } from '../../contexts/DarkModeContext';

function HowItWorks() {
  const { isDarkMode } = useDarkMode();
  const steps = [
    {
      id: 1,
      icon: "📚",
      title: "تصفح الحصص",
      text: "استعرض جميع الحصص والدورات المتاحة واختر ما يناسب مستواك واهتماماتك."
    },
    {
      id: 2,
      icon: "🛒",
      title: "اشترك مع المدرس",
      text: "انضم مباشرة إلى الحصة وتفاعل مع المدرس. اسأل أسئلتك واحصل على شرح مخصص يساعدك على الفهم."
    },
    {
      id: 3,
      icon: "👩‍🎓",
      title: "تعلم بسهولة",
      text: "استمتع بتجربة تعليمية سلسة وممتعة من خلال أدوات بسيطة شروحات واضحة ودعم متواصل."
    }
  ];

  return (
    <section className={`how-it-works ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className="overlay"></div>
      
      {/* Floating Animation Elements */}
      <div className="floating-elements">
        <div className="floating-element element-1">📚</div>
        <div className="floating-element element-2">🔬</div>
        <div className="floating-element element-3">🧮</div>
        <div className="floating-element element-4">⚗️</div>
        <div className="floating-element element-5">🌍</div>
        <div className="floating-element element-6">🔭</div>
        <div className="floating-element element-7">📐</div>
        <div className="floating-element element-8">🧪</div>
        <div className="floating-element element-9">⭐</div>
        <div className="floating-element element-10">✨</div>
      </div>
      
      <div className="container text-center">
        <h6 className="subtitle">طريقة استخدام علمي</h6>
        <h2 className="title">كيف يعمل؟</h2>
        <div className="row steps-row">
          {steps.map((step, index) => (
            <div className="col-md-4 step" key={step.id}>
              <div className="icon-box">
                <div className="diamond">
                  <span className="icon">{step.icon}</span>
                </div>
              </div>
              <h5 className="step-title">{step.title}</h5>
              <p className="step-text">{step.text}</p>
              {index !== steps.length - 1 && <div className="dashed-line"></div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
